import React, { Component } from "react";
import { Select } from "antd";
import nanoid from 'nanoid';
const Option = Select.Option;

class SearchBar extends Component {
  constructor(props){
    super(props)
    // console.log('search bar created!')
  }

  state = {
    data: []
  };

  handleChange = value => {
    // console.log("handle value:", value);
    // this.setState({ value });
    // fetch(value, data => this.setState({ data }));
  }; 

  render() {
    const { onSearchChange, value = [] } = this.props;
    const { data } = this.state;
    const options = data.map(d => {
      // console.log("d:", d);
      return <Option key={nanoid()}>{d.text}</Option>;
    });
    // console.log("Search bar value:", value);
    // if(value.length > 0) {
    //   if(!initValue.includes(value)) initValue.push(value)
    // }
    
  
    const selectValue = value.length > 0 ? value : [];

    // console.log("selectValue:", selectValue);
    return (
      <div style={{ margin: "16px" }}>
        <Select
          // mode="multiple"
          mode="tags"
          tokenSeparators={[","]}
          value={selectValue}
          placeholder={"Search bar"}
          //notFoundContent=""
          style={{ width: "95%" }}
          //defaultActiveFirstOption={false}
          //showArrow={false}
          //filterOption={false}
          onChange={onSearchChange}
        >
          {options}
        </Select>
      </div>
    );
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/dashboard/SearchBar.js